import { createAction, props } from '@ngrx/store';

import { ClientActionTypes } from './types';

export const init = createAction(ClientActionTypes.Init);

export const clientSelected = createAction(
  ClientActionTypes.ClientSelected,
  props<{ clientId: number }>()
);

export const destroyed = createAction(ClientActionTypes.Destroyed);
